import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../component/ui/tooltip";
import { Loader2, Trash2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../../../component/form/form-layout";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddUpdatePackage = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  packageData = null,
  Style,
}) => {
  console.log(packageData);
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const metas = Object.fromEntries(
    packageData?.metas?.map((m) => [m.meta_key, m.meta_value]) ?? []
  );
  const [searchClient, setSearchClient] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [mainProducts, setMainProducts] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);
  const [loadingPackages, setLoadingPackages] = useState(false);
  const initialMainId = packageData?.main_product ? Number(packageData.main_product.parent_id) : null;
  const initialSubId = packageData?.sub_product_id
    ? Number(packageData.sub_product_id)
    : null;
  const initialPackageId = packageData?.deal_package
    ? Number(metas.deal_package)
    : null;
  const [projectList, setProjectList] = useState([]);
  const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

  // console.log("packageData", packageData)

  useEffect(() => {
    loadMainProducts();
  }, []);

  useEffect(() => {
    if (initialMainId) {
      loadSubProducts(initialMainId).then(() => {
        if (initialSubId) {
          loadPackages(initialSubId);
        }
      });
    } else if (initialSubId) {
      loadPackages(initialSubId);
    }
  }, [initialMainId, initialSubId]);

  useEffect(() => {
    if (packageData) {
      formik.setFieldValue("packagename", packageData?.packagename);
      formik.setFieldValue("amount", packageData?.amount);
      formik.setFieldValue("discount", packageData?.discount);
      formik.setFieldValue("oldprice", packageData?.oldprice);
      formik.setFieldValue("tagline", packageData?.tagline);
      formik.setFieldValue("numberofrevisions", packageData?.numberofrevisions);
      formik.setFieldValue("concepts", packageData?.concepts);
      formik.setFieldValue("show_pkg", packageData?.show_pkg);
      formik.setFieldValue("features", stripHtml(packageData.features || ""));

      // const addressMeta = packageData?.meta?.find(
      //   (item) => item.meta_key === "address"
      // );
      // const phoneMeta = packageData?.meta?.find(
      //   (item) => item.meta_key === "phone"
      // );
      // const emailMeta = packageData?.meta?.find(
      //   (item) => item.meta_key === "email"
      // );

      // formik.setFieldValue("address", addressMeta?.meta_value);
      // formik.setFieldValue("phone", phoneMeta?.meta_value);
      // formik.setFieldValue("email", emailMeta?.meta_value);
      // formik.setFieldValue("extra_meta", packageData?.meta);
    }
  }, []);

  const validationSchema = yup.object({
    main_product: yup.number().required("This Field is Required"),
    sub_product_id: yup.number().required("This Field is Required"),
    packagename: yup.string().required("This Field is Required"),
    features: yup.string().required("This Field is Required"),
    amount: yup.number().required("This Field is Required"),
    discount: yup.number().required("This Field is Required"),
    oldprice: yup.number().required("This Field is Required"),
    tagline: yup.string().required("This Field is Required"),
    numberofrevisions: yup.string().required("This Field is Required"),
    concepts: yup.string().required("This Field is Required"),
    // show_pkg: yup.number().required("This Field is Required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      main_product: initialMainId || "",
      sub_product_id: packageData?.sub_product_id
        ? Number(packageData.sub_product_id)
        : "",
      packagename: packageData?.metas?.packagename || "",
      category: "",
      features: packageData?.features || "",
      amount: "",
      discount: "",
      oldprice: "",
      tagline: "",
      numberofrevisions: "",
      concepts: "",
      show_pkg: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        sub_product_id: Number(values.sub_product_id),
        packagename: values.packagename,
        category: Number(values.sub_product_id),
        features: values.features,
        amount: Number(values.amount),
        discount: Number(values.discount),
        oldprice: Number(values.oldprice),
        tagline: values.tagline,
        numberofrevisions: Number(values.numberofrevisions),
        concepts: Number(values.concepts),
        // show_pkg: Number(values.show_pkg),
      };

      console.log("data ", data);

      try {
        const url = packageData?.packageid
          ? `packages/update-package/${packageData?.packageid}`
          : "packages/add-package";

        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });

        onSubmit(apiRes?.message || "Deal saved successfully");

        formik.resetForm();
        onClose();
      } catch (error) {
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  useEffect(() => {
    const textarea = document.querySelector("textarea[name='features']");
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [formik.values.features]);

  const loadMainProducts = async () => {
    setLoadingMain(true);
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });
      setMainProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading main products:", err);
    } finally {
      setLoadingMain(false);
    }
  };

  const loadSubProducts = async (mainId) => {
    if (!mainId) {
      setSubProducts([]);
      return;
    }
    setLoadingSub(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${mainId}`,
      });
      setSubProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading sub-products:", err);
      setSubProducts([]);
    } finally {
      setLoadingSub(false);
    }
  };

  const loadPackages = async (subProductId) => {
    if (!subProductId) {
      setPackages([]);
      return;
    }
    setLoadingPackages(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-product-packages/${subProductId}`,
      });
      setPackages(res?.data || []);
    } catch (err) {
      console.warn("Error loading packages:", err);
      setPackages([]);
    } finally {
      setLoadingPackages(false);
    }
  };

  // Handlers for selects
  const handleMainSelect = async (option) => {
    const id = option?.value || "";

    formik.setFieldValue("main_product", id);
    formik.setFieldValue("sub_product_id", "");
    setSubProducts([]);
    setPackages([]);

    if (id) {
      await loadSubProducts(id);
    }
  };

  const handleSubSelect = async (option) => {
    const id = option?.value || "";
    formik.setFieldValue("sub_product_id", id);
    setPackages([]);

    if (id) {
      await loadPackages(id);
    }
  };

  const [packageFeatures, setPackageFeatures] = useState();

  const handlePackageSelect = (option) => {
    const id = option?.value || "";
    const pkg = packages.find((p) => Number(p.packageid) === Number(id));
    formik.setFieldValue("packagename", pkg?.packagename || "");
    // set features from package if exists
    if (pkg?.features) {
      formik.setFieldValue("features", stripHtml(pkg.features || ""));
      setPackageFeatures(stripHtml(pkg?.features || ""));
    } else {
      // 👇 clear the textbox if "Add Other" or no features exist
      formik.setFieldValue("features", "");
      setPackageFeatures(stripHtml(pkg?.features || ""));
    }
  };

  const subProductsUnique = subProducts.filter(
    (v, i, a) =>
      a.findIndex(
        (t) =>
          Number(t.id ?? t.subproductid ?? t.productid) ===
          Number(v.id ?? v.subproductid ?? v.productid)
      ) === i
  );
  const packagesUnique = packages.filter(
    (v, i, a) =>
      a.findIndex((t) => Number(t.packageid) === Number(v.packageid)) === i
  );

  const mainOptions = mainProducts.map((mp) => ({
    value: mp.id ?? mp.productid ?? mp.main_product_id ?? mp.id,
    label: mp.products || mp.name || mp.title || `#${mp.id}`,
  }));
  const subOptions = subProductsUnique.map((sp) => ({
    value: sp.id ?? sp.subproductid ?? sp.productid,
    label: sp.products || sp.name || sp.title || `#${sp.id}`,
  }));
  const packageOptions = [
    ...packagesUnique.map((pk) => ({
      value: pk.packageid,
      label: pk.packagename || `#${pk.packageid}`,
    })),
    { value: 3, label: "Add Other" },
  ];

  const editMainId = metas?.main_product ? Number(metas.main_product) : null;
  const editSubId = packageData?.sub_product_id
    ? Number(packageData.sub_product_id)
    : null;
  const editPackageId = packageData?.deal_package
    ? Number(packageData.deal_package)
    : null;

  useEffect(() => {
    let mounted = true;
    const runPrefill = async () => {
      try {
        if (editMainId) {
          formik.setFieldValue("main_product", editMainId, false);

          await loadSubProducts(editMainId);
        }

        if (editSubId) {
          const existsInSub = subProducts.some(
            (sp) =>
              Number(sp.id ?? sp.subproductid ?? sp.productid) ===
              Number(editSubId)
          );
          if (!existsInSub) {
            setSubProducts((prev) => {
              const merged = [
                ...prev,
                {
                  id: editSubId,
                  products:
                    // packageData?.deal_product_name || `Product #${editSubId}`,
                    packageData?.sub_product_id || `Product #${editSubId}`,
                },
              ];
              // ✅ remove duplicates by id/subproductid/productid
              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) =>
                      Number(t.id ?? t.subproductid ?? t.productid) ===
                      Number(v.id ?? v.subproductid ?? v.productid)
                  ) === i
              );
              return unique;
            });
          }

          formik.setFieldValue("sub_product_id", editSubId, false);

          await loadPackages(editSubId);

          if (editPackageId) {
            const existsPkg = packages.some(
              (pk) => Number(pk.packageid) === Number(editPackageId)
            );
            if (!existsPkg) {
              setPackages((prev) => {
                const merged = [
                  ...prev,
                  {
                    packageid: editPackageId,
                    packagename: metas?.packagename,
                  },
                ];
                // ✅ remove duplicates by packageid
                const unique = merged.filter(
                  (v, i, a) =>
                    a.findIndex(
                      (t) => Number(t.packageid) === Number(v.packageid)
                    ) === i
                );
                return unique;
              });
            }

            formik.setFieldValue("deal_package_id", editPackageId, false);

            formik.setFieldValue(
              "deal_package",
              packageData?.deal_package || metas?.deal_package_name || "",
              false
            );
          }
        } else if (!editSubId && editPackageId) {
          const existsPkg = packages.some(
            (pk) => Number(pk.packageid) === Number(editPackageId)
          );
          if (!existsPkg) {
            setPackages((prev) => {
              const merged = [
                ...prev,
                {
                  packageid: editPackageId,
                  packagename: metas?.packagename,
                },
              ];
              // ✅ remove duplicates by packageid
              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) => Number(t.packageid) === Number(v.packageid)
                  ) === i
              );
              return unique;
            });
          }
          formik.setFieldValue("deal_package_id", editPackageId, false);
        }
      } catch (err) {}
    };

    if (packageData) {
      runPrefill();
    }

    return () => {
      mounted = false;
    };
  }, [packageData]);

  const selectedMainOption =
    mainOptions.find(
      (o) => Number(o.value) === Number(formik.values.main_product)
    ) || null;
  const selectedSubOption =
    subOptions.find(
      (o) => Number(o.value) === Number(formik.values.sub_product_id)
    ) || null;
  const selectedPackageOption =
    packageOptions.find(
      (o) => Number(o.value) === Number(formik.values.deal_package_id)
    ) || null;

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>
            {/* Main Product */}

            <FeildWraper width="100%">
              <FormLabel required>Main Product</FormLabel>
              {/* <Select
                className="text-sm"
                classNamePrefix="react-select"
                value={selectedMainOption}
                onChange={handleMainSelect}
                options={mainOptions}
                isLoading={loadingMain}
                isClearable
                placeholder="Select main product..."
                menuPortalTarget={document.body}
                menuPosition="fixed"
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") {
                    setSearchClient(value);
                    if (searchTimeout) clearTimeout(searchTimeout);

                    if (value.length >= 3) {
                      const timeout = setTimeout(() => {
                        onLoadMoreClients(1, value.trim());
                      }, 400);
                      setSearchTimeout(timeout);
                    } else if (value.length === 0) {
                      const timeout = setTimeout(() => {
                        onLoadMoreClients(1, "");
                      }, 300);
                      setSearchTimeout(timeout);
                    }
                  }
                }}
                onMenuOpen={() => {
                  if (ClientList.length === 0 && !isLoadingClients) {
                    onLoadMoreClients(1, "");
                  }
                }}
                onMenuClose={() => {
                  if (searchClient.length > 0) {
                    setSearchClient("");
                    onLoadMoreClients(1, "");
                  }
                }}
                onMenuScrollToBottom={() => {
                  if (!searchClient && hasMoreClients && !isLoadingClients) {
                    onLoadMoreClients(page + 1, "");
                  }
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              /> */}

              <Select
                className="text-sm"
                classNamePrefix="react-select"
                value={selectedMainOption}
                onChange={handleMainSelect}
                options={mainOptions}
                isLoading={loadingMain}
                isClearable
                placeholder="Select main product..."
                menuPortalTarget={document.body}
                menuPosition="fixed"
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              />
              {formik.touched.main_product && formik.errors.main_product && (
                <FeildError>{formik.errors.main_product}</FeildError>
              )}
            </FeildWraper>

            {/* Sub product */}

            <FeildWraper>
              <FormLabel required>Sub Product</FormLabel>
              <Select
                value={
                  subOptions.find(
                    (option) => option.value === formik.values.sub_product_id
                  ) || null
                }
                onChange={(selectedOption) => {
                  formik.setFieldValue(
                    "sub_product_id",
                    selectedOption ? selectedOption.value : ""
                  );
                  handleSubSelect(selectedOption); // if you have custom logic
                }}
                options={subOptions}
                isLoading={loadingSub}
                isClearable
                placeholder="Select sub product..."
                classNamePrefix="react-select"
                className="text-sm"
                menuPortalTarget={document.body}
                noOptionsMessage={() =>
                  formik.values.main_product
                    ? "No sub-products"
                    : "Select main product first"
                }
                menuPosition="fixed"
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              />
              {formik.touched.sub_product_id &&
                formik.errors.sub_product_id && (
                  <FeildError>{formik.errors.sub_product_id}</FeildError>
                )}
            </FeildWraper>

            {/*Package name */}

            <FeildWraper>
              <FormLabel required>Package</FormLabel>
              <input
                type="text"
                name="packagename"
                value={formik.values.packagename}
                onChange={formik.handleChange}
                placeholder="Package Name"
              />
              {formik.touched.packagename &&
              Boolean(formik.errors.packagename) ? (
                <span style={{ color: "red" }} className="ps-1">
                  {formik.errors.packagename}
                </span>
              ) : null}
            </FeildWraper>

            {/* Amount */}
            <FeildWraper>
              <FormLabel required>Amount</FormLabel>
              <input
                type="number"
                name="amount"
                value={formik.values.amount}
                onChange={formik.handleChange}
                placeholder="Amount"
              />
              {formik.touched.amount && formik.errors.amount && (
                <FeildError>{formik.errors.amount}</FeildError>
              )}
            </FeildWraper>

            {/* Discount */}
            <FeildWraper>
              <FormLabel required>Discount</FormLabel>
              <input
                type="number"
                name="discount"
                value={formik.values.discount}
                onChange={formik.handleChange}
                placeholder="Discount"
              />
              {formik.touched.discount && formik.errors.discount && (
                <FeildError>{formik.errors.discount}</FeildError>
              )}
            </FeildWraper>

            {/* old Price */}
            <FeildWraper>
              <FormLabel required>Old Price</FormLabel>
              <input
                type="number"
                name="oldprice"
                value={formik.values.oldprice}
                onChange={formik.handleChange}
                placeholder="Old Price"
              />
              {formik.touched.oldprice && formik.errors.oldprice && (
                <FeildError>{formik.errors.oldprice}</FeildError>
              )}
            </FeildWraper>

            {/* Tagline */}
            <FeildWraper>
              <FormLabel required>Tag line</FormLabel>
              <input
                type="text"
                name="tagline"
                value={formik.values.tagline}
                onChange={formik.handleChange}
                max="100"
              />
              {formik.touched.tagline && formik.errors.tagline && (
                <FeildError>{formik.errors.tagline}</FeildError>
              )}
            </FeildWraper>

            {/* concepts */}
            <FeildWraper>
              <FormLabel required>Concepts</FormLabel>
              <input
                type="text"
                name="concepts"
                value={formik.values.concepts}
                onChange={formik.handleChange}
              />
              {formik.touched.concepts && formik.errors.concepts && (
                <FeildError>{formik.errors.concepts}</FeildError>
              )}
            </FeildWraper>

            {/* <FeildWraper>
              <FormLabel required>Show pkg</FormLabel>
              <input
                type="text"
                name="show_pkg"
                value={formik.values.show_pkg}
                onChange={formik.handleChange}
              />
              {formik.touched.show_pkg && formik.errors.show_pkg && (
                <FeildError>{formik.errors.show_pkg}</FeildError>
              )}
            </FeildWraper> */}

            {/* numberofrevisions */}
            <FeildWraper>
              <FormLabel required>Number Of Revisions</FormLabel>
              <input
                type="text"
                name="numberofrevisions"
                value={formik.values.numberofrevisions}
                onChange={formik.handleChange}
              />
              {formik.touched.numberofrevisions &&
                formik.errors.numberofrevisions && (
                  <FeildError>{formik.errors.numberofrevisions}</FeildError>
                )}
            </FeildWraper>

            {/* Features */}
            <FeildWraper width="100%">
              <FormLabel>Features</FormLabel>
              <textarea
                name="features"
                value={formik.values.features}
                onChange={formik.handleChange}
                rows={6}
                placeholder="Write or edit package features here..."
              />
            </FeildWraper>
          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {packageData?.packageid ? "Update" : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpdatePackage;
